import { Component, OnInit } from '@angular/core';
import { BranchService } from '../../services/branch.service';

@Component({
    selector: 'app-branch-list',
    imports: [],
    providers: [BranchService],
    templateUrl: './branch-list.component.html',
    styleUrl: './branch-list.component.css'
})
export class BranchListComponent implements OnInit {

  constructor(private branchService: BranchService){}
  ngOnInit(): void {
    console.log('aqui')
    this.branchService.get().subscribe(response => {
      console.log('response',response)
    }, error => {
      console.log('error', error)
      console.log(error)
    })
  }

}
